import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import styles from './table.css';
import classnames from 'classnames';

class Table extends Component {
  render() {
    return (
      <table styleName={classnames('table', this.props.subTable ? 'sub-table' : '')}>
        <colgroup>
          {this.props.columnWidths.map((colummnWidth, index) => {
            return <col style={{ width: colummnWidth }} key={index} />;
          })}
        </colgroup>
        {this.props.children}
      </table>
    );
  }
}
Table.propTypes = {
  columnWidths: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node,
  subTable: PropTypes.bool,
};

Table.defaultProps = {
  subTable: false,
};
export default CSSModules(Table, styles, { allowMultiple: true });
